import * as React from "react";
import { useCart } from "react-use-cart";
import { AppBar, Toolbar, Button } from "@mui/material";
import { NavLink } from "react-router-dom";
import { FaCartShopping } from "react-icons/fa6";
import { FaCommentDots } from "react-icons/fa6";
import { FaHome } from "react-icons/fa";

export default function Header() {
  const { totalItems } = useCart();
  return (
    <AppBar
      position="static"
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "end",
        backgroundColor: "white",
        boxShadow: "none",
      }}
    >
      <Toolbar>
        <NavLink to="/" className="Navlink">
          <Button>
            <FaHome size={22} className="IconLink" />
          </Button>
        </NavLink>
        <NavLink to="/contact">
          <Button>
            <FaCommentDots size={22} className="IconLink" />
          </Button>
        </NavLink>
        <NavLink to="/cart">
          <Button>
            <FaCartShopping size={22} className="IconLink" /> {totalItems}
          </Button>
        </NavLink>
      </Toolbar>
    </AppBar>
  );
}
